module.exports = __webpack_public_path__ + "static/img/resolution.afa374b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resolution.png
// module id = 9j6z
// module chunks = 3